import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  Collection,
  ExecuteOperationOnPipe, Form,
  ModelProxy,
  ModelProxyWithForm,
  useValue,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import * as UI from 'ui'
import PermissionGroupDescription from 'pages/app/settings/permissions/partials/PermissionGroupDescription'
import PermissionGroupTitle from 'pages/app/settings/permissions/partials/PermissionGroupTitle'
import SelectedPermissionRoles from 'pages/app/settings/permissions/partials/SelectedPermissionRoles'
import InnerPermissionRoles from 'pages/app/settings/permissions/partials/InnerPermissionRoles'
import InnerPermissionUsers from 'pages/app/settings/permissions/partials/InnerPermissionUsers'
import { WhenIsPiping } from '@morningtrain/react-pipelines'
import { LoadingSpinner } from 'ui/animations'

export default function PermissionGroupRolesSmartview () {
  const header = (
    <UI.WithSubtitle subtitle={<PermissionGroupDescription />}>
      <PermissionGroupTitle />
    </UI.WithSubtitle>
  )

  const footer = (
    <UI.ButtonWrap>
      <UI.SubmitButton>
        <UI.Text className='flex space-x-3 items-center' block>
          <div>
            <Translation name='actions.submit' />
          </div>
          <WhenIsPiping>
            <LoadingSpinner color='white' />
          </WhenIsPiping>
        </UI.Text>
      </UI.SubmitButton>
    </UI.ButtonWrap>
  )

  const id = useValue('id')

  return (
    <ModelProxy resourceName='permissions.groups' id={id}>
      <Form submitTo='store' preventParentOperationRefresh>
        <SelectedPermissionRoles />
        <Translator namespace='settings.permissions.smartviews.permission_group_roles_smartview'>
          <Smartview size='lg' header={header} footer={footer}>
            <Collection resourceName='permissions.roles'>
              <WhenCollectionIsNotEmpty>
                <UI.VerticalList>
                  <UI.SecondaryHeading>
                    <Translation name='titles.users' />
                  </UI.SecondaryHeading>
                  <InnerPermissionUsers />
                  <UI.SecondaryHeading>
                    <Translation name='titles.roles' />
                  </UI.SecondaryHeading>
                  <InnerPermissionRoles />
                </UI.VerticalList>
              </WhenCollectionIsNotEmpty>
            </Collection>
          </Smartview>
        </Translator>
        <ExecuteOperationOnPipe resourceName='permissions.groups' operationName='index' />
      </Form>
    </ModelProxy>
  )
}
